<template>
  <div class="system-settings">
    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-cog"></i> 系统设置</h2>
        <button class="btn btn-primary" @click="saveSettings">保存设置</button>
      </div>
      <div class="settings-section">
        <div class="setting-item">
          <span class="setting-label"><i class="fas fa-eye"></i> 实时监控</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="settings.realTimeMonitoring">
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="setting-item">
          <span class="setting-label"><i class="fas fa-robot"></i> 自动处理</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="settings.autoHandle">
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="setting-item">
          <span class="setting-label"><i class="fas fa-volume-up"></i> 声音提醒</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="settings.soundAlert">
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="setting-item">
          <span class="setting-label"><i class="fas fa-envelope"></i> 邮件通知</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="settings.emailNotification">
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="setting-item">
          <span class="setting-label"><i class="fas fa-bell"></i> 消息推送</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="settings.pushNotification">
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="setting-item">
          <span class="setting-label"><i class="fas fa-shield-alt"></i> 安全模式</span>
          <label class="toggle-switch">
            <input type="checkbox" v-model="settings.safetyMode">
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemSettings',
  data() {
    return {
      settings: {
        realTimeMonitoring: true,
        autoHandle: false,
        soundAlert: true,
        emailNotification: false,
        pushNotification: true,
        safetyMode: true
      }
    }
  },
  methods: {
    saveSettings() {
      console.log('Saving settings:', this.settings)
      alert('设置已保存')
    }
  }
}
</script>

<style scoped>
.system-settings {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
  overflow: hidden;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
}

.settings-section {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.setting-label {
  font-size: 15px;
  color: #c4b5fd;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
}

.setting-label i {
  background: linear-gradient(135deg, #8b5cf6 0%, #22d3ee 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 28px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(139, 92, 246, 0.3);
  transition: .4s;
  border-radius: 28px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 3px;
  bottom: 3px;
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  transition: .4s;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(139, 92, 246, 0.4);
}

input:checked + .toggle-slider {
  background: linear-gradient(90deg, rgba(139, 92, 246, 0.6) 0%, rgba(34, 211, 238, 0.5) 100%);
  box-shadow: inset 0 2px 4px rgba(139, 92, 246, 0.3);
}

input:checked + .toggle-slider:before {
  transform: translateX(28px);
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
}

.btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(100, 100, 100, 0.1);
  transition: left 0.3s ease;
  z-index: -1;
}

.btn:hover::before {
  left: 0;
}

.btn-primary {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}
</style>
